import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { currencyFormatter } from "../../../../_metronic/_helpers";

export default function ImportDonaturTable({ dataTable }) {
  const columns = [
    {
      dataField: "type",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Tipe"
    },
    {
      dataField: "name",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Nama"
    },
    {
      dataField: "greeting",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Sapaan"
    },
    {
      dataField: "hp",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Hp"
    },
    {
      dataField: "email",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Email"
    },
    {
      dataField: "address",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Alamat"
    },
    {
      dataField: "district",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Kecamatan"
    },
    {
      dataField: "city",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Kota"
    },
    {
      dataField: "province",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Provinsi"
    },
    {
      dataField: "postal_code",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Kode Pos"
    },
    {
      dataField: "nik",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "NIK"
    },
    {
      dataField: "npwp",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "NPWP"
    },
    {
      dataField: "is_alive",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Status Hidup",
      formatter: cell => {
        return (
          <>
            <span>{cell ? "Hidup" : "Meninggal"}</span>
          </>
        );
      }
    },
    {
      dataField: "is_active",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Status Aktif",
      formatter: cell => {
        return (
          <>
            <span>{cell ? "Aktif" : "Non-Aktif"}</span>
          </>
        );
      }
    },
    {
      dataField: "kode_rekening",
      headerClasses: "text-nowrap",
      classes: "text-nowrap",
      text: "Kode Rekening"
    }
  ];
  return (
    <>
      <BootstrapTable
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        remote
        keyField="uuid"
        data={dataTable === null ? [] : dataTable}
        columns={columns}
        // pagination={paginationFactory()}
      />
    </>
  );
}
